import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Navigate } from 'react-router';

import { useUserDispatch } from '../../providers/UserContext';
import { useAuth, useAuthDispatch } from '../../providers/AuthContext';
import {
  SET_AUTH_USER,
  SET_PAGE_TITLE,
  USER_FETCH,
} from '../../providers/actionTypes';
import LoadingMask from '../shared/LoadingMask';
import { usePageTitleDispatch } from '../../providers/PageTitleContext';
import getUserIdentity from '@/util/getUserIdentity';

const page_title = 'Authenticate';

const Callback = (): React.JSX.Element => {
  const user_dispatch = useUserDispatch();
  const auth = useAuth();
  const auth_dispatch = useAuthDispatch();

  const pageTitleDispatch = usePageTitleDispatch();

  useEffect(() => {
    pageTitleDispatch({ type: SET_PAGE_TITLE, payload: page_title });
  }, [pageTitleDispatch]);

  useEffect(() => {
    if (auth?.user_manager && auth?.user === undefined) {
      const setAuthUser = (auth_user: typeof auth.user) => {
        auth_dispatch({ type: SET_AUTH_USER, payload: auth_user });
        if (auth_user) {
          user_dispatch({ type: USER_FETCH, payload: getUserIdentity(auth_user) });
        }
      };

      auth.user_manager
        .getUser()
        .then((auth_user) => {
          if (auth_user) {
            setAuthUser(auth_user);
          } else {
            auth.user_manager
              ?.signinRedirectCallback()
              .then(setAuthUser)
              .catch((error) => console.log(error));
          }
        })
        .catch((error) => console.log(error));
    }
  }, [auth?.user_manager, auth?.user, auth_dispatch, user_dispatch]);

  return (
    <Box sx={{ display: 'flex' }}>
      <LoadingMask />
      {auth.user && <Navigate to='/' replace />}
    </Box>
  );
};

export default Callback;
